<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <!-- Reason ID -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    Reason ID:<span style="color:#ff0000">*</span>
                </label>
                <input type="text" class="content" [(ngModel)]="reasonId" (keypress)="keyPressAlphaNumeric($event)"
                    [disabled]="eventType=='EDIT'">
            </div>
        </div>
        <!-- Reason Name -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    Reason Name:<span style="color:#ff0000">*</span>
                </label>
                <input type="text" class="content" [(ngModel)]="reasonName">
            </div>
        </div>
        <!-- Category -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    Category:<span style="color:#ff0000">*</span>
                </label>
                <select class="drpDown" style="width:220px" [(ngModel)]="categoryId">
                    <option *ngFor="let category of categoryDropDown" [value]="category.value">
                        {{ category.value }}
                    </option>
                </select>
            </div>
        </div>
        <!-- Include In Investigation -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    Include In Investigation:<span style="color:#ff0000">*</span>
                </label>
                <select class="category" style="width:220px" [(ngModel)]="includeInInvestigation">
                    <option *ngFor="let booleanVal of yesNoList" [value]="booleanVal.id">
                        {{ booleanVal.value }}
                    </option>
                </select>
            </div>
        </div>
        <!-- Include In All -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">
                    Include In All:<span style="color:#ff0000">*</span>
                </label>
                <select class="category" style="width:220px" [(ngModel)]="includeInAll">
                    <option *ngFor="let booleanVal of yesNoList" [value]="booleanVal.id">
                        {{ booleanVal.value }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel"> CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SAVE</button>
    </div>
</div>